export const SHOP_API_URL = 'ui/organization/shop';

export const shopQueryKeys = {
  all: [SHOP_API_URL],
  storeListing: (storeListingId: string) => [
    ...shopQueryKeys.all,
    storeListingId,
  ],
};
